import React from 'react'
import { Row, Col, Form, Button, OverlayTrigger, Popover } from 'react-bootstrap'
import FeatherIcon from '@components/shared/FeatherIcon'

const { I18n } = window

interface FilterOption {
  id: string
  name: string
}

interface FilterEventsProps {
  order: string
  status: string
  statusOptions: FilterOption[]
  formPath: string
}

const FilterEvents: React.FC<FilterEventsProps> = ({ order, status, statusOptions, formPath }) => {
  const clearedFilter = { status: '', order: '' }
  const popover = (
    <Popover id="event-filters">
      <Popover.Content className="m-2">
        <Row>
          <Col>
            <p className="text-green-800 font-weight-semibold">
              {I18n.t('vm.views.shift_registrations.filters')}
            </p>
          </Col>
        </Row>
        <Form action={formPath}>
          <Row>
            <Col>
              <Form.Group controlId="status">
                <Form.Label>{I18n.t('vm.views.shift_registrations.status')}</Form.Label>
                <Form.Control as="select" name="filter[status]" defaultValue={status}>
                  <option key="default-status" value="">
                    {I18n.t('vm.views.shift_registrations.all')}
                  </option>
                  {statusOptions.map((optionValue, idx) => (
                    <option value={optionValue.id} key={`status-${idx}`}>
                      {optionValue.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group controlId="order">
                <Form.Label>{I18n.t('vm.views.shift_registrations.date')}</Form.Label>
                <Form.Control as="select" name="filter[order]" defaultValue={order}>
                  <option></option>
                  <option value="date_asc">
                    {I18n.t('vm.views.shift_registrations.ascending')}
                  </option>
                  <option value="date_desc">
                    {I18n.t('vm.views.shift_registrations.descending')}
                  </option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <hr />
              <div className="d-flex justify-content-between align-items-center">
                <a
                  href={formPath}
                  className="btn btn-link link-green-800 cursor-pointer font-weight-semibold"
                >
                  {I18n.t('vm.views.shift_registrations.clear_all')}
                </a>
                <Button type="submit" variant="primary" className="btn-vm-primary mr-2">
                  {I18n.t('vm.views.shift_registrations.apply')}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Popover.Content>
    </Popover>
  )

  return (
    <OverlayTrigger trigger="click" placement="bottom" overlay={popover} rootClose>
      <Button variant="primary" className="btn-vm-primary">
        {I18n.t('vm.views.shift_registrations.filters')} <FeatherIcon name="chevron-down" />
      </Button>
    </OverlayTrigger>
  )
}

export default FilterEvents
